/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultCounterCard from "examples/Cards/CounterCards/DefaultCounterCard";

const PROGRAMS_BASE_COUNT = 1000;
const PROGRAMS_START_DATE = new Date("2025-05-15T00:00:00");
const MS_PER_DAY = 1000 * 60 * 60 * 24;

function getProgramsCount() {
  const daysSinceStart = Math.floor((Date.now() - PROGRAMS_START_DATE.getTime()) / MS_PER_DAY);
  return PROGRAMS_BASE_COUNT + Math.max(daysSinceStart, 0);
}

function Counters() {
  return (
    <MKBox component="section" py={3}>
      <Container>
        <Grid container item xs={12} lg={9} sx={{ mx: "auto" }}>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={35}
              suffix="+"
              title="Years of Experience"
              description="From small business to Fortune 100 companies, we've worked with them all"
            />
          </Grid>
          <Grid item xs={12} md={4} display="flex">
            <Divider orientation="vertical" sx={{ display: { xs: "none", md: "block" }, mx: 0 }} />
            <DefaultCounterCard
              count={17}
              suffix="+"
              title="Programming Languages"
              description="C#, Java, PHP, Python, C++, Javascript and more"
            />
            <Divider orientation="vertical" sx={{ display: { xs: "none", md: "block" }, ml: 0 }} />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={getProgramsCount()}
              suffix="+"
              title="Programs"
              description="Applications we've created for our clients over the years"
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Counters;
